<template>
  <table class="freezeTable" ref='freezeTable'>
    <th v-for="(col, index) in columns"
            :key="index">
      <template v-if="index === 0">
            <i class="fa fa-lock start"
            ref='freezeStart' title="冻结列"
            @mousedown="mousedownFreeze($event,index)"
            :style="{left:position.left+'px'}"
            >
            </i>
      </template>
      <template v-if="index === columns.length - 1">
            <i class="fa fa-lock end"
            ref='freezeEnd' title="冻结列"
            @mousedown="mousedownFreeze($event,index)"
            :style="{right:position.right+'px'}"></i>
      </template>
    </th>

  </table>
</template>

<script>
export default {
  name: 'freeze-lock',
  props: ['columns'],
  inject: ['reportService'],
  data () {
    return {
      position: {left: 0, right: 0}
    }
  },
  mounted () {
    setTimeout(() => {
      let freezeLeft = this.reportService.report.freezeLeft
      let freezeRight = this.reportService.report.freezeRight
      let left = freezeLeft === 0 ? 0 : freezeLeft * COLUMN_WIDTH - LOCK_WIDTH - 100
      let right = freezeRight === 0 ? 0 : freezeRight * COLUMN_WIDTH - LOCK_WIDTH - 100
      this.position.left = left
      this.position.right = right
    }, 1000)
  },
  methods: {
    // 拖拽冻结列，第一个锁只能锁前面3列，每列的宽度固定是200，第二个锁锁后面最多2列
    mousedownFreeze (event, index) {
      let moveLeft = event.clientX - this.$refs.freezeStart[0].offsetLeft
      let moveRight = event.clientX - this.$refs.freezeEnd[0].offsetLeft
      document.onmousemove = (event) => {
        if (index === 0) {
          let left = event.clientX - moveLeft
          if (left < 0) {
            left = 0
          } else if (left > COLUMN_WIDTH * 5 - LOCK_WIDTH) {
            left = COLUMN_WIDTH * 5 - LOCK_WIDTH
          }
          this.position.left = left
        } else {
          let right = this.$refs.freezeTable.offsetWidth - (event.clientX - moveRight)
          if (right < 0) {
            right = 0
          } else if (right > 400 - LOCK_WIDTH) {
            right = 400 - LOCK_WIDTH
          }
          this.position.right = right
        }
      }
      this.stopMove()
    },
    stopMove () {
      document.onmouseup = (event) => {
        let freezeLeft = Math.ceil(this.position.left / COLUMN_WIDTH)
        let freezeRight = Math.ceil(this.position.right / COLUMN_WIDTH)
        this.reportService.report.freezeLeft = freezeLeft
        this.reportService.report.freezeRight = freezeRight
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }

}
const COLUMN_WIDTH = 190
const LOCK_WIDTH = 14
</script>

<style lang="scss">
.freezeTable{
  width: 100%;
  position: relative;
  border-collapse: collapse;
  th{
    height: 20px;
    max-width: 190px;
    min-width: 190px;
    .start{
      position: absolute;
      left: 0;
      top: 0;
      cursor: pointer;
    }
    .end{
      cursor: pointer;
      position: absolute;
      top: 0;
      right: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/report/design/freeze-lock.vue